(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('initSetupWizard', {
                parent: 'app',
                url: '/initSetupWizard',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/wizards/init-setup/init-setup.html',
                        controller: 'InitSetupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }]
                }
            })


        ;

    }
})();
